module.exports = __webpack_public_path__ + "static/img/ent-80.d843666.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-80.jpg
// module id = DhX1
// module chunks = 51